import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import _ from "vendor/lodash";
import Module from "global/sparta-module-utility";
import Utility from "community/module-utils-utility";
import urlCampaignCodeUtility from "community/url-campaign-code-utility";
import spartaTemplates from "modules/home-loans/links-module/1.0.1/js/templates";
export default class linksModule extends Module {





  constructor(options) {

    super(options);

    this.$target = $('#linksModule');


    this.bindAllMethod = Utility.bindAllMethod.bind(this);


    this.bindAllMethod();

    this.UrlLib = urlCampaignCodeUtility();

  }

  updateLink(response = {}, $link) {
    const UrlLib = this.UrlLib;
    const processed = $link.data('processed');
    const href = $link.attr('href');
    if (!processed && href && (href.indexOf('javascript:') === -1) && (href.indexOf('tel:') === -1)) {
      const {scsCampCode, subCampCode} = response;
      const newHref = UrlLib.applyCampaignCodes(`${href}`, scsCampCode, subCampCode);
      $link.attr('href', UrlLib.applyAffiliateCode(newHref, response))
    }
    $link.data('processed', true);
  };

  updateApplyOrPrequalifyLink(response = {}) {
    const updateLink = this.updateLink;
    return function () {
      const $link = $(this);
      updateLink(response, $link);
    };
  };

  updateAffiliateCodeOnly(response = {}) {
    const UrlLib = this.UrlLib;
    return function () {
      const $link = $(this);
      const href = $link.attr('href');
      const processed = $link.data('processed');
      if (!processed && href && (href.indexOf('javascript:') === -1) && (href.indexOf('tel:') === -1) && !/$#/.test(href)) {
        $link.attr('href', UrlLib.applyAffiliateCode(href, response))
      }
      $link.data('processed', true);
    };
  };






  updatePhoneNumbers(payload = {}) {


    const phoneNumber = payload.phoneNumber || spaParams.pageParams.foo;
    const $contactUs = $('.call-us, .number, .sc-phone-number');
    if (phoneNumber) {
      const barePhone = phoneNumber.replace(/[^\d]/g, '');
      const matches = barePhone.match(/(\d{3})(\d{3})(\d{4})/);
      if (matches && matches.length > 3) {
        const formattedPhone = `${matches[1]}.${matches[2]}.${matches[3]}`;
        $contactUs.text(formattedPhone);
        $contactUs.attr('href', `tel:1${barePhone}`);
      }
    } else {
      $contactUs.each((idx, el) => {
        const phoneNumber = $(el).text();
        if (phoneNumber) {
          const barePhone = phoneNumber.replace(/[^\d]/g, '');
          $contactUs.attr('href', `tel:1${barePhone}`);
        }
      });
    }

  }






  updateLinks(response = {}) {
    const payload = response.data;

    this.updatePhoneNumbers(payload)

    const $secureLinks = $(
      '.secure-sign-in, ' + 
      '#globalFooterModule .get-prequalified, ' + 
      '#ready-to-apply #ready-to-apply-link, ' + 
      '#large-tab-nav .icon.online-banking a, ' + 
      '#small-tab-nav .icon.online-banking a, ' + 
      '#closingCostsFallbackModule #schedule-appt, ' + 
      '#contactUsModule #schedule-appt, ' + 
      '#engagementModule #prequalify-now-medium, ' + 
      '.prequalify-now, ' +
      '.apply-now, ' +
      '.apply-or-prequalify, ' +
      '#engagementModule #apply-now-medium, ' + 
      '#engagementModule #schedule_an_appointment_engagment' 
    );
    const secureHost = spaParams.siteParams.secureHost;
    $secureLinks.each(function () {
      const $link = $(this);
      const href = $link.attr('href');
      if (href && secureHost && !_.includes(href, secureHost)) {
        $link.attr('href', `${secureHost}${href}`);
      }
    });
    if (!(payload.error || _.isEmpty(payload))) {
      const updateApplyOrPrequalifyLink = this.updateApplyOrPrequalifyLink(payload);
      $('.apply-or-prequalify').each(updateApplyOrPrequalifyLink);
      let updateNonSecureLink;
      if (/(subcampcode|scscampcode)/i.test(window.location.href)) {
        updateNonSecureLink = updateApplyOrPrequalifyLink;
      } else {
        updateNonSecureLink = this.updateAffiliateCodeOnly(payload);
      }
      $('a').not('.apply-or-prequalify').each(updateNonSecureLink);
    }
  }




  init() {
    const events = [

      'HOME_LOANS_OVERVIEW_PHONE_NUMBER_RATES_REQUEST_SUCCESS',
      'HOME_LOANS_OVERVIEW_PHONE_NUMBER_RATES_REQUEST_FAILURE',


      'HOME_LOANS_PHONE_NUMBER_REQUEST_SUCCESS',
      'HOME_LOANS_PHONE_NUMBER_REQUEST_FAILURE',


      'HOME_LOANS_LEARNING_MLO_INFO_REQUEST_SUCCESS'
    ];
    events.forEach(event => this.Events.sub(event, this.updateLinks));
  }

}
